import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter, FilterItem, FilterType, checkFilter } from '../models/filter';
import { FiltersPanelService } from '../filters-panel.service';

import { SHARED_MODULES } from '../../../../shared.';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';
import { SearchComponent } from '../../search/search.component';
import { TreeCheckboxComponent } from '../tree-checkbox/tree-checkbox.component';
import { TreeRadioComponent } from '../tree-radio/tree-radio.component';

@Component({
    selector: 'app-tree-filter',
    templateUrl: './tree-filter.component.html',
    styleUrls: ['./tree-filter.component.scss'],
	imports: [
		SHARED_MODULES,
		PhIconComponent,
		PhIconWrapperComponent,
		SearchComponent,
		TreeCheckboxComponent,
		TreeRadioComponent
	],
    standalone: true
})
export class TreeFilterComponent implements OnInit {

	@Input('filter') filter: Filter;
	@Input('content') content: HTMLElement;
	@Input('disabled') disabled: boolean = false;

	@Output('check') check: EventEmitter<void> = new EventEmitter<void>();
	@Output('search') search: EventEmitter<void> = new EventEmitter<void>();

	filterType = FilterType;
	lastScrollPosition: number = 0;

	get hideDelete(): boolean {
		if (this.filter.type == FilterType.RadioTree && this.filter.data.length) {
			return this.filter.checkingStrategy.any(this.filter.data[0].id as number);
		}
		return false;
	};

	constructor(private panelService: FiltersPanelService) {}

	ngOnInit() {
		this.panelService.getApplyPanel().subscribe((apply: boolean) => {
			if (!apply) this.clearSelected();
		});
	}

	isFixed(panel, content: HTMLElement): boolean {
		if (!panel.expanded) return false;
		const offset = panel._viewContainerRef.element.nativeElement.offsetTop - 70,
			height = panel._viewContainerRef.element.nativeElement.clientHeight;

		if (this.lastScrollPosition < content.scrollTop && offset + height < content.scrollTop + 50) {
			panel.expanded = false;
		}
		this.lastScrollPosition = content.scrollTop;
		if (offset == content.scrollTop) return false;
		return offset < content.scrollTop && offset + height > content.scrollTop;
	}

	checkElement(): void {
		if (this.filter.type == FilterType.RadioTree) this.filter.selectingStrategy.clear();
		this.setSelected(this.filter.data);
		this.check.emit();
	}

	setSelected(list: Array<FilterItem>, parentCheck: boolean = false): void {
		const selectedIds: Array<number> = this.filter.selectingStrategy.getSelected();

		list.forEach((element: FilterItem) => {
			if (
				this.filter.checkingStrategy.getKey(element.id as number).checked &&
				(this.filter.type !== this.filterType.CheckboxTree ||
					(!this.filter.searchQuery && !parentCheck || !!this.filter.searchQuery && !element.children.length))
			) {
				if (!selectedIds.includes(element.id as number)) this.filter.selectingStrategy.setSelected(element);
			} else {
				if (selectedIds.includes(element.id as number)) this.filter.selectingStrategy.removeSelected(element.id as number);
			}
			if (element.children.length)
				this.setSelected(element.children, this.filter.checkingStrategy.getKey(element.id as number).checked);
		});
	}

	removeSelected(id: number): void {
		this.filter.selectingStrategy.removeSelected(id);
		checkFilter(this.filter, this.filter.data, this.filter.selectingStrategy.getSelected());
		if (this.filter.type == FilterType.RadioTree) {
			this.filter.selectingStrategy.setSelected(this.filter.data[0]);
			this.filter.checkingStrategy.setKey(this.filter.data[0].id as number, true, false);
		}
		this.check.emit();
	}

	clearSelected(): void {
		this.filter.checkingStrategy.clear();
		this.filter.selectingStrategy.clear();
		checkFilter(this.filter, this.filter.data);
		if (this.filter.type == FilterType.RadioTree) {
			this.filter.selectingStrategy.setSelected(this.filter.data[0]);
			this.filter.checkingStrategy.setKey(this.filter.data[0].id as number, true, false);
		}
		this.check.emit();
	}

	setSearched(query: string): void {
		if (this.filter.searchQuery == query.trim()) return;
		this.filter.searchQuery = query.trim();
		this.filter.search(this.filter).subscribe((tree: Array<FilterItem>) => {
			this.filter.data = tree;
			if (this.filter.type == FilterType.CheckboxTree)
				checkFilter(
					this.filter,
					this.filter.data,
					this.filter.selectingStrategy.getSelected(),
					false,
					!!this.filter.searchQuery.length
				);
		});
	}
}